<template>
  <b-container fluid>
    <backlink />
    <h1>Échanges</h1>
    <!-- Une ligne par échange : la commande d'échange (CM…-E) et le retour des matériels
         d'origine (RTR…-E), créés ensemble depuis la boutique (SFD Échanges et stockage 1.1). -->
    <div class="ibox">
      <div class="ibox-content">
        <b-form inline class="mb-3" @submit.prevent="load">
          <b-input-group>
            <b-form-input id="exchange-search" v-model="search" placeholder="N° de commande ou de retour, référence, affaire, agence" style="min-width: 380px" />
            <b-input-group-append>
              <b-button type="submit" variant="outline-primary"><i class="far fa-search"></i></b-button>
            </b-input-group-append>
          </b-input-group>
          <span class="ml-3 text-muted">{{ exchanges.length }} échange{{ exchanges.length > 1 ? "s" : "" }}</span>
        </b-form>
        <div class="table-wrapper">
          <b-table hover show-empty :busy="isBusy" :items="exchanges" :fields="fields" empty-text="Aucun échange">
            <template slot="renting" slot-scope="data">
              <router-link v-if="$root.isAuthorized('renting_show')" :to="{ name: 'RentingDetail', params: { id: data.item.renting.id } }">{{ data.item.renting.number }}</router-link>
              <template v-else>{{ data.item.renting.number }}</template>
            </template>
            <template slot="business_return" slot-scope="data">
              <router-link v-if="$root.isAuthorized('business-return_show')" :to="{ name: 'BusinessReturnDetail', params: { id: data.item.business_return.id } }">{{ data.item.business_return.number }}</router-link>
              <template v-else>{{ data.item.business_return.number }}</template>
            </template>
            <template slot="created_at" slot-scope="data">{{ data.value | moment("DD-MM-YYYY") }}</template>
            <template slot="agency" slot-scope="data">{{ data.value ? data.value.internal_number : "-" }}</template>
            <template slot="business" slot-scope="data">{{ data.value.number }} - {{ data.value.name }}</template>
            <template slot="lines" slot-scope="data">
              <div v-for="line in data.value" :key="line.original_reference.id">
                {{ line.original_reference.internal_code }}
                <small class="text-muted">
                  <i class="far fa-long-arrow-right"></i>
                  {{ line.replacement_reference ? line.replacement_reference.internal_code : "à préparer" }}
                </small>
              </div>
            </template>
            <template slot="renting_status" slot-scope="data">
              <b-badge variant="primary">{{ data.item.renting.status.name }}</b-badge>
            </template>
            <template slot="return_status" slot-scope="data">
              <b-badge :variant="data.item.business_return.status.slug == 'business-return-annule' ? 'danger' : 'primary'">{{ data.item.business_return.status.name }}</b-badge>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "ExchangeList",
  data() {
    return {
      exchanges: [],
      search: "",
      isBusy: false,
      fields: [
        { key: "renting", label: "Commande d'échange" },
        { key: "business_return", label: "Retour" },
        { key: "created_at", label: "Création" },
        { key: "agency", label: "Agence" },
        { key: "business", label: "Affaire" },
        { key: "lines", label: "Références (origine → remplacement)" },
        { key: "renting_status", label: "Statut commande" },
        { key: "return_status", label: "Statut retour" },
      ],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.isBusy = true;
      this.$http
        .get(process.env.BACK_API_URL + "exchange", { params: { search: this.search || null } })
        .then((response) => {
          this.exchanges = (response.data && response.data.exchanges) || [];
        })
        .catch(() => {
          this.exchanges = [];
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Exchange/ExchangeList.vue